<template>
  <div class="formDialog">
    <el-form :inline="true" :rules="rules" ref="formRef" :model="tableParams">
      <el-row :span="24">
        <el-col :span="24">
          <el-form-item label="消息通知" prop="messageTitle">
            <el-input
              style="width: 100%"
              v-model="tableParams.messageTitle"
              placeholder="请输入消息通知的标题,建议最多不超过30字"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="消息内容" prop="messageText">
            <div style="width: 100%; height: 240px; margin-bottom: 50px">
              <quill-editor
                v-model="tableParams.messageText"
                ref="content"
                :options="editorOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @change="onContentChange($event)"
                @ready="onEditorReady($event)"
              >
              </quill-editor>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="定时发送" prop="sendTime">
            <el-date-picker
              v-model="tableParams.sendTime"
              type="datetime"
              placeholder="请选择时间"
              format="YYYY-MM-DD HH:mm:ss"
            >
            </el-date-picker>
            不设置时间则立即发送
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="接收人群" prop="messagePointType">
            <el-radio
              v-model="tableParams.messagePointType"
              label="1"
              size="large"
              >按部门</el-radio
            >
            <!-- <el-radio
              v-model="tableParams.messagePointType"
              label="2"
              size="large"
              >按角色</el-radio
            > -->
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div
            v-if="tableParams.messagePointType === '1'"
            class="select-content"
          >
            <el-tree
              ref="treeRef"
              :data="treeData"
              node-key="deptId"
              highlight-current
              :default-expanded-keys="[]"
              :props="{ label: 'name' }"
              @check="currentChangePerson"
              :expand-on-click-node="true"
              show-checkbox
            ></el-tree>
          </div>
          <div v-else class="select-content">
            <el-checkbox-group v-model="tableParams.messageRoleId">
              <el-checkbox
                size="large"
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleId"
              >
                {{ item.roleName }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="buttonprimary">
      <el-button type="primary" @click="sendOut(formRef)">发送</el-button>
      <el-button type="primary">重置</el-button>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watchEffect,
  watch,
} from "vue";
import { notifymessageinstall } from "@/api/messageCenter/messageCenterApi.js";
import { getRoleList } from "@/api/system/role.js";
import { queryOrganList } from "@/api/system";
import { ElMessage } from "element-plus";
import util from "@util/js";
import moment from "moment";
export default defineComponent({
  props: {
    itemRow: {
      type: Object,
      default: () => {},
    },
    Visible: {
      type: Boolean,
      default: false,
    },
    stateData: {
      type: Number,
      default: 1,
    },
  },
  components: {},
  setup(props, context) {
    const formRef = ref(null);
    const content = ref(null);
    const treeRef = ref(null);

    const state = reactive({
      roleList: [],
      formVisible: false,
      roleListSource: [],
      treeData: [],
      rules: {
        messageTitle: [
          {
            required: true,
            message: "请输入消息标题",
            trigger: "blur",
          },
        ],
        messageText: [
          {
            required: true,
            message: "请输入消息标题",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请输入消息内容",
            trigger: "blur",
          },
        ],
      },
      tableParams: {
        messagePointType: "1",
        messageTitle: "",
        messageText: "",
        sendTime: "",
        messagePointId: [],
        messageRoleId: [],
      },
      editorOption: {
        // 定义富文本编辑器显示
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗、倾斜、下划线、删除线

            [{ header: 1 }, { header: 2 }], // 标题一、标题二
            [{ list: "ordered" }, { list: "bullet" }], // 列表

            [{ color: [] }, { background: [] }], // 字体颜色、背景颜色
          ],
        },
      },
    });
    watch(
      () => state.tableParams.sendTime,
      () => {
        state.tableParams.sendTime = moment(state.tableParams.sendTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
    );
    watchEffect(() => {
      if (state.tableParams.messagePointType === "1") {
        state.tableParams.messageRoleId = [];
      } else {
        state.tableParams.messagePointId = [];
      }
    });
    // 修改成员部门时当前选中节点变化时触发的事件
    const currentChangePerson = (item, val) => {
      state.tableParams.messagePointId = val.checkedKeys;
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await queryOrganList();
      const options = { pid: "parentId", id: "deptId", rootPid: result.top };
      const treeData = util.arrayToTree(result.deptList, options);
      state.dataSource = result.deptList;
      state.treeData = treeData;
    };
    queryOrganTreAsync();
    // 获取角色列表
    const queryRoleAsync = async () => {
      const res = await getRoleList();
      state.roleList = state.roleListSource = res.roleList;
    };
    queryRoleAsync();
    const methods = {
      async sendOut(formEl) {
        if (!formEl) return;
        await formEl.validate(async (valid, fields) => {
          if (valid) {
            if (
              state.tableParams.messagePointId.length !== 0 ||
              state.tableParams.messageRoleId.length !== 0
            ) {
              // console.log(state.tableParams);
              // return;
              // if (state.tableParams.sendTime == "Invalid date") {
              //   state.tableParams.sendTime = "";
              // }
              state.tableParams = util.formatForm(state.tableParams);
              const res = await notifymessageinstall(state.tableParams);
              if (res.code === 0) {
                state.formVisible = false;
                ElMessage.success("操作成功");
                context.emit("submit");
              }
            } else {
              ElMessage.warning("请选择接收人群");
            }
          } else {
            console.log("error submit!", fields);
          }
        });
      },
      onEditorReady() {
        // 富文本准备时的事件
        console.log("富文本准备时的事件");
      },
      onEditorFocus(val, editor) {
        // 富文本获得焦点时的事件
        console.log(val, 66666666); // 富文本获得焦点时的内容=
      },
      onEditorBlur(val) {
        // 富文本失去焦点时的事件
        state.tableParams.messageText = val.value.innerHTML.substring(
          val.value.innerHTML.indexOf('"true">') + 7,
          val.value.innerHTML.indexOf("</div>")
        );
      },
      onContentChange(val) {
        console.log(5555555);
        // 富文本内容改变时的事件 // 富文本改变时的内容
      },
    };
    const initForm = () => {
      if (props.stateData === 2) {
        console.log(props.itemRow, 66666666666666);
        setTimeout(() => {
          content.value && content.value.setHTML(props.itemRow.messageText);
        }, 0);
        treeRef.value &&
          treeRef.value.setCheckedKeys([props.itemRow.messagePointId], false);
        state.tableParams = { ...props.itemRow };
      } else {
        treeRef.value && treeRef.value.setCheckedKeys([], false);
        content.value && content.value.setHTML("");
        state.tableParams = { ...props.itemRow };
      }
    };
    const stop = watchEffect(() => {
      initForm();
    });
    watch(
      () => props.itemRow,
      (v) => {
        console.log(656565656);
        initForm();
      },
      { deep: true }
    );
    stop();
    return {
      ...toRefs(state),
      ...methods,
      formRef,
      content,
      treeRef,
      currentChangePerson,
    };
  },
});
</script>
<style lang="scss" scoped>
.formDialog {
  .el-form-item {
    width: 100%;
    :deep(.ql-toolbar) {
      width: 100%;
    }
    :deep(.ql-container) {
      width: 100%;
    }
  }
  .select-content {
    width: 100%;
    height: 140px;
    margin-bottom: 50px;
    overflow: auto;
  }
  .buttonprimary {
    text-align: center;
  }
}
</style>
